import React from 'react'
import '../css/SidebarOptions.css'
import Add from '@mui/icons-material/Add';

export default function SidebarOptions() {
  return (
    <div className="sidebarOptions">
      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-2128-100-c8IzsZA6jk4j8EoaHKjX4qoPmRJJ2eZZ.jpeg"
          alt=""
        />
        <p><a href="https://www.quora.com/topic/Design" target='blank'>Design</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-2128-100-c8IzsZA6jk4j8EoaHKjX4qoPmRJJ2eZZ.jpeg"
          alt=""
        />

<p><a href="https://www.quora.com/topic/Design" target='blank'>Design</a></p> 
      </div>
      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-1140-100-24q3tiv4WhPssc5TGwf0mvCM5aiqGVXW.jpeg"
          alt=""
        />
         <p><a href="https://www.quora.com/topic/Science" target='blank'>Science</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="	https://qph.cf2.quoracdn.net/main-thumb-t-2177-100-JiR07D1TQSfeQzRvWXomVaY4Poj2f8Yb.jpeg"
          alt=""
        />
       <p><a href="https://www.quora.com/topic/Music" target='blank'>Music</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-801-100-Sf8h894FXbQZQit0TeqDrrqS6xw6dwCQ.jpeg"
          alt=""
        />
         <p><a href="https://www.quora.com/topic/Technology" target='blank'>Technology</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-4401-100-ujeijwoyjzehsarbtxjpevuundcsuefq.jpeg"
          alt=""
        />
       <p><a href="https://www.quora.com/topic/Finance" target='blank'>Finance</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="	https://qph.cf2.quoracdn.net/main-thumb-t-9656-100-hrlbvdsnnfoncmvdwfpiokblohcafibl.jpeg"
          alt=""
        />
        <p><a href="https://www.quora.com/topic/Legal" target='blank'>Legal</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="	https://qph.cf2.quoracdn.net/main-thumb-t-1996-100-o6F5aK25iZbYaizXZOPQ7biRrfMkRCVE.jpeg"
          alt=""
        />
       <p><a href="https://www.quora.com/topic/Jobs" target='blank'>Jobs</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-1026-100-ohvgqriqzmtjrnillbxqoyfstjxhmlcu.jpeg"
          alt=""
        />
       <p><a href="https://www.quora.com/topic/Food" target='blank'>Food</a></p>
      </div>

      <div className="sidebarOption">
        <img
          src="https://qph.cf2.quoracdn.net/main-thumb-t-2879-100-qtdlfoiqjavzcujshegidjubyjyqrlja.jpeg"
          alt=""
        />
        <p><a href="https://www.quora.com/topic/Salary" target='blank'>Salary and wages</a></p>
      </div>
      <div className="sidebarOption">
        <Add />
        <p className="text">Discover Spaces</p>
      </div>
    </div>
  );
}

